module.exports = __webpack_public_path__ + "img/AufDemForcki.b4c0e63a.svg";